import * as React from 'react';

import FooterDesktop from './FooterDesktop';
import FooterMobile from './FooterMobile';

interface IProps {
  peach?: boolean;
}

export default function Footer(props: IProps) {
  return (
    <>
      <FooterDesktop {...props} />
      <FooterMobile {...props} />
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer.tsx